import { ReactNode } from 'react';

import { Typography } from '@/shared/components/atoms';

const HomeCardWrapper: React.FC<{
  children: ReactNode;
  title: string | React.ReactNode;
  icon: ReactNode;
  headerTabs?: ReactNode;
}> = ({ children, title, icon, headerTabs }) => {
  return (
    <div className='flex min-h-[400px] flex-col overflow-hidden rounded-2xl bg-background-neutral-99'>
      <div className='flex min-h-[70px] items-center justify-between gap-16 border-b-xs border-neutralVariant-90 p-16'>
        <div className='flex items-center gap-8'>
          <span className='text-primary-default'>{icon}</span>
          {typeof title === 'string' ? (
            <Typography weight='bold'>{title}</Typography>
          ) : (
            title
          )}
        </div>
        {headerTabs}
      </div>
      <div className='flex flex-grow'>{children}</div>
    </div>
  );
};

export default HomeCardWrapper;
